import { createFileRoute } from '@tanstack/react-router'
import { ResultsPage } from '../components/ResultsPage'

// Season N's results, the full form of designs/20261017-seasons.md §4:
// ?round=N here means season N's round, whatever season is running now.
// ?post= opens that post's sheet: the comment email links here once the
// round is final (designs/20261019-comments.md §4).
export const Route = createFileRoute('/l/$slug/s/$n/results')({
  params: { parse: (p) => ({ n: Number(p.n) }), stringify: (p) => ({ n: String(p.n) }) },
  validateSearch: (s: Record<string, unknown>): { round?: number; post?: number } => ({
    round: typeof s.round === 'number' ? s.round : undefined,
    post: typeof s.post === 'number' ? s.post : undefined,
  }),
  component: SeasonResults,
})

function SeasonResults() {
  const { slug, n } = Route.useParams()
  const search = Route.useSearch()
  const navigate = Route.useNavigate()
  return (
    <ResultsPage
      slug={slug}
      season={n}
      round={search.round}
      post={search.post}
      onRound={(round) => navigate({ search: { round }, replace: true })}
      onOpened={() => navigate({ search: (prev) => ({ ...prev, post: undefined }), replace: true })}
    />
  )
}
